export default "__VITE_ASSET__CJBoUbBq__"